import TagBox from 'devextreme-react/tag-box';
import React, { useEffect, useState } from 'react';
import { formEditorApi } from '../../../api/formEditorApi';
const FormTagBox = ({ value, ts_form_editor_id, dm_coso_id, onValueChanged, disabled }) => {
  const [dataSource, setDataSource] = useState([]);
  useEffect(() => {
    handleReload();
  }, []);
  const handleReload = async () => {
    const res = await formEditorApi.SelectDataSource(ts_form_editor_id, dm_coso_id, 0);
    if (res.is_success) {
      setDataSource(res.data);
    }
  };
  return (
    <TagBox
      dataSource={dataSource}
      displayExpr={'text'}
      valueExpr={'id'}
      //   placeholder={translate("Chọn năm học")}
      disabled={disabled}
      value={value}
      stylingMode="underlined"
      width={'100%'}
      showSelectionControls={true}
      onValueChanged={(e) => {
        if (e.event && onValueChanged) {
          onValueChanged(e.value);
        }
      }}
    //   ref={cmb}
    //   onValueChanged={(e) => {
    //     onValueChanged(e.value);
    //   }}
    />
  );
};

export default FormTagBox;
